const PopupStyles = () => {
  return (
    <style jsx global>{`
      
      .isRtl *{
        letter-spacing: 0 !important
      }
      .isRtl,
      .isRtl .accordion ,
      .isRtl .product-compare .specs-container,
      .isRtl .product-page .title, 
      .isRtl .prod-title {
        direction: rtl;
      }

      .isRtl  header,
      .isRtl  .row {
        direction: ltr;
      }

      .isRtl .dropdown-menu,
      .isRtl .product-landing .card-body,
      .isRtl .product-compare {
        text-align: right;
      }

      .isRtl #boutique-dropdown-button + .dropdown-menu > a {
        font-size: 14px;
      }

      @media (max-width: 768px) {
        .action-buttons .dropdown a {
          white-space: normal;
        }
      }
    `}</style>
  );
};

export default PopupStyles;
